import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-536e5e5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "d-flex ms-3 mb-5" }
const _hoisted_4 = { class: "d-flex flex-column ms-3" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "class_qr_canvas" }, null, -1))

import { onMounted, ref, watch } from 'vue';
import CoreDialog from "../../../framework/components/dialog/CoreDialog.vue";
import { DialogHandler } from "./DialogHandler";
import { translation } from "../../lang/Translation";
import QRCode from "qrcode";
import { ContentsUrl } from "../../utils/ContentsUrl";
import { SessionUser } from "../../utils/SessionUser";
import { MessageDialog } from "../../../framework/frontend/MessageDialog";
import MemberInvitationListVue from "../../pages/classroom/sections/MemberInvitationList.vue";
import { ClassRoomService } from "../../biz/remote/ClassRoomService";
import { ClassMembers } from "../../../server/dto/generated/ClassMembers";
import router from "../../router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassRoomDialog',
  setup(__props) {

const t = translation; //
const pageTitle = t.to("クラスルームへの招待", "invite_class_room");
const dialogId = DialogHandler.classRoomDialogId;

const toPresentation = (class_name: string) => {
  DialogHandler.hideDialog(dialogId);
  router.push({ name: "ClassPresentationPage", params:{ class_name : class_name}})
};

const memberList = ref<ClassMembers[]>([]);
const classList = ref<{className:string,url:string}[]>([]);

// URLのコピーを実施
const copyUrl = async (url:string) => {
  var textarea = document.getElementsByTagName("textarea")[0];
  // 文字をすべて選択
  textarea.select();
  // コピー
  if (navigator.clipboard) {
    navigator.clipboard.writeText(url);
    MessageDialog.alert(t.to("コピーしました", "copied"));
  } else {
    await MessageDialog.error(
      t.to("すみません。このブラウザは対応していないようです", "not_support_device")
    );
  }
};

const openTab = async (url:string)=>{
  window.open(url,"_blank");
}

const openQR = async (url:string)=>{
  const canvas = document.getElementById("class_qr_canvas");
  if (!canvas) return;
  QRCode.toCanvas(canvas, url, function (error) {
    if (error) console.error(error);
    canvas.setAttribute("style", "width:400px;height:400px");
  });

}

// メンバーリストの変更をDeep,ImmediateでWatch
watch(memberList,(items:ClassMembers[])=>{
  const teacher_id = SessionUser.instance.userId;
  // クラス名だけの配列にして重複を除去
  classList.value = items.map((item)=> { 
    const url = ContentsUrl.instance.getClassRoomUrl(teacher_id,
      item.className,
      SessionUser.instance.token
    )
    return {className: item.className ,url:url}
  })
  .reduce((prev:{className:string,url:string}[],current:{className:string,url:string})=>{
    if(!prev.find((value)=>value.className===current.className)){ 
      prev.push(current) 
    }
    return prev
  },[])

},{deep:true,immediate:true})


const onAddUser = (member: ClassMembers) => {
  memberList.value.push(member);
};
const onDeleteUser = (index: number) => {
  memberList.value.splice(index, 1);
};


// ダイアログロード時の処理
onMounted(() => {
  DialogHandler.onOpenDialog(dialogId, async function () {
    const teacher_id = SessionUser.instance.userId;
    const biz = new ClassRoomService();
    const response = await biz.getMembers(teacher_id);
    memberList.value = response.data;
    // const className = "test"

  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-xl': true },
    title: _unref(pageTitle)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: toPresentation
      }, _toDisplayString(_unref(t).to("閉じる", "close")), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(MemberInvitationListVue, {
              list: memberList.value,
              "on-add-user": onAddUser,
              "on-delete-user": onDeleteUser,
              class: "w-100"
            }, null, 8, ["list"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(t).to("2. メンバーを招待", "desc_invite_to_class")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classList.value, (classItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: classItem.className,
                  class: "w-100 mb-3"
                }, [
                  _createElementVNode("label", null, _toDisplayString(classItem.className) + "クラスの" + _toDisplayString(_unref(t).to("招待用URL", "invite_url")), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      readonly: "",
                      value: classItem.url
                    }, null, 8, _hoisted_8),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: ($event: any) => (copyUrl(classItem.url))
                    }, _toDisplayString(_unref(t).to("コピー", "copy")), 9, _hoisted_9),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: ($event: any) => (openQR(classItem.url))
                    }, _toDisplayString(_unref(t).to("QRコード", "qr_code")), 9, _hoisted_10),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      type: "button",
                      onClick: ($event: any) => (openTab(classItem.url))
                    }, _toDisplayString(_unref(t).to("別タブで開く", "open_tab")), 9, _hoisted_11),
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: ($event: any) => (toPresentation(classItem.className))
                    }, _toDisplayString(_unref(t).to("クラス発表会", "class_presentation")), 9, _hoisted_12)
                  ])
                ]))
              }), 128)),
              _hoisted_13
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})